import {
  CLEAR_DETAILS,
  GET_EVENT_DETAILS,
  GET_EVENT_DETAILS_START,
  GET_EVENT_DETAILS_SUCCESS,
  GET_EVENT_DETAILS_FAIL,
  GET_EVENT_DETAILS_REFETCH_START,
  GET_EVENT_DETAILS_REFETCH_SUCCESS,
  GET_EVENT_DETAILS_REFETCH_FAIL,
  INIT_EVENT_CREATION_SUCCESS,
  RESET_NEWLY_CREATED,
} from 'actions/eventDetails';

export const defaultState = {
  error: false,
  event: {},
  loading: true,
  newlyCreated: false,
};

export default function details(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case CLEAR_DETAILS:
      return { ...defaultState };
    case GET_EVENT_DETAILS:
    case GET_EVENT_DETAILS_START: {
      return {
        ...state,
        error: false,
        loading: true,
      };
    }
    case GET_EVENT_DETAILS_REFETCH_START: {
      return {
        ...state,
        error: false,
      };
    }
    case GET_EVENT_DETAILS_REFETCH_SUCCESS:
    case GET_EVENT_DETAILS_SUCCESS: {
      const polling = payload.jobId && payload.status === 'RUNNING';
      return {
        ...state,
        error: false,
        loading: polling,
        event: polling ? { ...state.event } : { ...payload },
      };
    }
    case GET_EVENT_DETAILS_REFETCH_FAIL:
    case GET_EVENT_DETAILS_FAIL: {
      return {
        ...state,
        event: {},
        error: payload.json,
        loading: false,
      };
    }
    case INIT_EVENT_CREATION_SUCCESS: {
      return {
        ...state,
        event: {},
        newlyCreated: true,
      };
    }
    case RESET_NEWLY_CREATED: {
      return {
        ...state,
        newlyCreated: false,
      };
    }
    default:
      return state;
  }
}
